export const APIS = {
    // baseurl:  "https://test.fightitaway.com:8444/", 
    // userBaseUrl:"https://test.fightitaway.com/api/",
    // mainUrl: "https://test.fightitaway.com"
    baseurlApi:  "https://app.smartdietplanner.com:4444/api/",
    baseurl:  "https://app.smartdietplanner.com:8443/", 
    userBaseUrl:"https://app.smartdietplanner.com/api/", 
    mainUrl: "https://app.smartdietplanner.com" 
}
export const SUBAPIS = {
    saveDietRecall: "saveDietRecall?userId=",
    getDietRecall: "getDietRecall?userId=",
    login: "login",
    refs: "refs",
    summary: "summary",
    search: "customers?",
    updateUser: "customers",
    getToken: "getToken?",
    updateExpDate: "customer-update/update-premium",
    updateReferral: "customer-update/update-referral",
    fetchDietPlanNames: "custom/dietPlan/fetchDietPlanNames",
    fetchSlotsDetails: "custom/dietPlan/fetchSlotsDetails",
    updateSlotsDetails: "custom/dietPlan/updateSlot",
    fetchAllCategories: "custom/dietPlan/fetchAllCategories",
    updateCategory:"custom/dietPlan/updateCategory",
    updateFoodItems:"custom/dietPlan/updateFoodItems",
    fetchFoodDetails: "custom/dietPlan/fetchFoodDetails",
    user: "user"
}